import { useDataSubmit } from 'Simple/Data'

export function useOnTimeout(props) {
  let submit = useDataSubmit({
    context: 'tab',
    viewPath: props.viewPath,
  })

  return function onTimeout() {
    submit({ type: 'back/app' })
  }
}
